module.exports = __webpack_public_path__ + "media/images/onboarding-1-3f89e9a5a96c219873ac12745d27f510.jpg";